import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../../APIHelpers/Responses";

export const studySubjectScreenFailedReasonServices = {
  //Subject Screen Failed Reason
  addNewStudySubjectScreenFailedReason,
  updateStudySubjectScreenFailedReasonData,
  deleteStudySubjectScreenFailedReasonData,
  softDeleteRestoreStudySubjectScreenFailedReason,
  getStudySubjectScreenFailedReasonData,
};

// Add New Study Subject Screen Failed Reason
async function addNewStudySubjectScreenFailedReason(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudySubjectScreenFailedReason`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Study Subject Screen Failed Reason
async function updateStudySubjectScreenFailedReasonData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudySubjectScreenFailedReasonData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Study Subject Screen Failed Reason
async function softDeleteRestoreStudySubjectScreenFailedReason(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudySubjectScreenFailedReason`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Subject Screen Failed Reason
async function deleteStudySubjectScreenFailedReasonData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudySubjectScreenFailedReasonData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Subject Screen Failed Reason
async function getStudySubjectScreenFailedReasonData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySubjectScreenFailedReasonData/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySubjectScreenFailedReasonData/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}